import axios from "axios";

export default {
  namespaced: true,
  state: {
    requests: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    requestsMessage: ''
  },
  mutations: {
    RECEIVED_REQUESTS(state, payload) {
      state.requests = payload;
      state.isReceiving = false;
    },
    RECEIVING_REQUESTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_REQUEST(state) {
      state.isReceiving = true;
    },
    RECEIVED_REQUEST(state, payload) {
      state = Object.assign(state, {
        requests: [...state.requests, payload],
        isReceiving: false,
      })
    },

    UPDATED_REQUESTS(state, payload) {
      let index = state.requests.findIndex(request => request._id === payload._id);
      state = Object.assign(state, {
        requests: state.requests.map((request, i) => {
          if (i === index) return Object.assign({}, request, payload);
          return request;
        }),
        isUpdating: false,
        requestsMessage: 'Requests has been updating!',
      })
    },
    UPDATING_REQUESTS(state) {
      state.isUpdating = true;
    },
    DELETED_REQUESTS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.requests.findIndex(request => request._id === payload._id);
      console.log(indexToDelete);
      let requests = [...state.requests];
      requests.splice(indexToDelete, 1);
      state = Object.assign(state, {
        requests: [...requests],
        isDeleting: false,
        idToDelete: null,
        requestsMessage: 'Request has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_REQUESTS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteRequestRequest({dispatch}, payload) {
      dispatch("deletingRequest", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/request/' + payload._id;
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "delete", url: url, headers: header});
      dispatch("deleteRequest", response.data);
      return response.data;
    },
    async insertRequestRequest({dispatch}, payload) {
      dispatch("receivingRequests");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/request';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "post", url: url, headers: headers, data: data})
      .then(response=> {
        dispatch("receiveRequest", response.data);
      })
      .catch((error) => {
        console.log(error);
      });	
    },
    async insertRequestWithFileRequest({dispatch}, payload) {
      dispatch("receivingRequests");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/request';
      let data = new FormData();
      data.append('file', payload.filedata, payload.filename); 
      delete payload['filedata'];
      delete payload['filename'];
      data.append('payload', JSON.stringify(payload));
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then(response=> {
        let request = response.data.request;
        request.transaction = response.data.transaction;
        dispatch("receiveRequest", request);
      })
      .catch((error) => {
        console.log(error);
      });	
    },
    async getRequestsRequest({dispatch}) {
      try{
        dispatch("receivingRequests");
        var token = localStorage.getItem('token');
        var url = 'https://api.tradexc.com:3000/get/requests';
        var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "get", url: url, headers: header});
        dispatch("receiveRequests", response.data);
        return response.data;
      }
      catch(e){return null;}
    },
    updateRequestRequest({dispatch}, payload) {
      dispatch("updatingRequest");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/request/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then((response)=> {
        dispatch("updateRequest", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateRequestStatusRequest({dispatch}, payload) {
      dispatch("updatingRequest");
      let id = payload.requestid;
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/request/status/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateRequest", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateRequestImageRequest({dispatch}, payload) {
      dispatch("updatingRequest");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.tradexc.com:3000/update/request/image/' + id;
      data = new FormData();
      data.append('image', payload.requestimage, payload.imagename); 
      delete payload['requestimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updateRequest", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    receiveRequests({commit}, payload) {
      commit("RECEIVED_REQUESTS", payload)
    },
    receivingRequests({commit}) {
      commit("RECEIVING_REQUESTS")
    },
    receiveRequest({commit}, payload) {
      commit("RECEIVED_REQUEST", payload)
    },
    receivingRequest({commit}) {
      commit("RECEIVING_REQUESTS")
    },
    updateRequest({commit}, payload) {
      commit("UPDATED_REQUESTS", payload)
    },
    updatingRequest({commit}) {
      commit("UPDATING_REQUESTS")
    },
    deleteRequest({commit}, payload) {
      commit("DELETED_REQUESTS", payload)
    },
    deletingRequest({commit}, payload) {
      commit("DELETING_REQUESTS", payload)
    }
  },
};
